export const formatDateTime = (date: number | string, isEndOfDay?: boolean) => {
  if (typeof date === 'string') return date;
  if (!date) return '';

  const dateFormat = new Date(Number(date));

  if (isNaN(dateFormat.getTime())) {
    return '';
  }

  const isMidnight =
    dateFormat.getHours() === 0 &&
    dateFormat.getMinutes() === 0 &&
    dateFormat.getSeconds() === 0 &&
    dateFormat.getMilliseconds() === 0;

  if (isMidnight && isEndOfDay) {
    dateFormat.setHours(23, 59, 59, 999);
  }

  const isoString = dateFormat?.toISOString();

  return isoString;
};

export const normalizedPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\+84/, '0');
};
